module.exports = __webpack_public_path__ + "static/media/cartola.70acc607.svg";